import {log} from '@vanguard/logger'
import {useQuery, UseQueryResult} from 'react-query'
import {api} from '../services/api'
import {useAuth} from '../stores/AuthStore'
import {AuthClient} from '../types'

const QUERY_STALE_TIME = 1000 * 60 * 30 // 30 minutes

const queryKeys = {
  all: () => [{resource: 'idp-organizations'}] as const,
  list: () => [{...queryKeys.all()[0], type: 'list'}] as const,
}

export const useAuthClients = <TData = AuthClient[]>(options?: {
  select?: (data: AuthClient[]) => TData
  onSuccess?: (data: TData) => void
  useIdpAuthentication: boolean
}): UseQueryResult<TData> => {
  const {authenticationStatus, getAccessToken} = useAuth()

  return useQuery(
    queryKeys.list(),
    async (): Promise<AuthClient[]> => {
      const accessToken = await getAccessToken()
      const response = await api.auth.listAuthClients(accessToken)

      if (response.result === 'success') {
        return response.data
      }

      throw new Error(response.error.message)
    },
    {
      enabled:
        options?.useIdpAuthentication &&
        (authenticationStatus === 'idp_authenticated' ||
          authenticationStatus === 'authenticated'),
      staleTime: QUERY_STALE_TIME,
      select: options?.select,
      onSuccess: options?.onSuccess,
      onError: (error) => {
        if (error instanceof Error) {
          log.error(error)
        } else {
          log.error(new Error(JSON.stringify(error)))
        }
      },
    },
  )
}
